import { z } from "zod";
import * as themeScheme from "@ecp-redux/dto/themeSettings/themeSettings.schemes";

export const IBoxActiveAccountMessagesScheme = z.object({
  active_account_name_placeholder:
    themeScheme.MessageScheme.default("Imie i nazwisko"),
  active_account_phone_placeholder:
    themeScheme.MessageScheme.default("Nr telefonu"),
  active_account_password_placeholder:
    themeScheme.MessageScheme.default("Hasło"),
  active_account_password_details: themeScheme.MessageScheme.default(
    "Użyj co najmniej 8 znaków - wielkich i małych liter oraz cyfry"
  ),
  active_account_repeat_password_placeholder:
    themeScheme.MessageScheme.default("Powtórz hasło"),

  active_account_name_error_empty_field: themeScheme.MessageScheme.default(
    "Pole nie może być puste"
  ),
  active_account_name_error_minimum_characters:
    themeScheme.MessageScheme.default("Minimalna liczba znaków to 3"),
  active_account_name_error_maximum_characters:
    themeScheme.MessageScheme.default("Maksymalna liczba znaków to 50"),
  active_account_name_error_message: themeScheme.MessageScheme.default(
    "Podaj imie i nazwisko"
  ),
  active_account_phone_number_validate_error_message:
    themeScheme.MessageScheme.default("Numer telefonu niepoprawny"),
  active_account_password_field_is_required:
    themeScheme.MessageScheme.default("Hasło niepoprawne"),
  active_account_password_field_validation_error:
    themeScheme.MessageScheme.default(
      "Użyj co najmniej 8 znaków - wielkich i małych liter oraz cyfry"
    ),
  active_account_password_field_same_password_error_validation:
    themeScheme.MessageScheme.default("Hasła są niezgodne"),
  active_account_button_action:
    themeScheme.MessageScheme.default("Utwórz hasło"),
  active_account_required_checkbox_error:
    themeScheme.MessageScheme.default("Pole wymagane*"),
  active_account_select_all_consent:
    themeScheme.MessageScheme.default("Zaznacz wszystkie"),
  active_account_accept_terms_consent: themeScheme.MessageScheme.default(
    `Akceptuję postanowienia <a href="#">Regulaminu serwisu</a>`
  ),
  active_account_consent_communication_consent:
    themeScheme.MessageScheme.default(
      "Wyrażam zgodę na przetwarzanie moich danych osobowych w celach komunikacyjnych"
    ),
  active_account_consent_communication_expansion_consent:
    themeScheme.MessageScheme.default(
      "Essa é uma mensagem de teste para a expansão do consentimento de comunicação"
    ),
  active_account_consent_marketing_consent: themeScheme.MessageScheme.default(
    "Wyrażam zgodę na przetwarzanie moich danych osobowych w celach marketingowych marketingowych marketingowych marketingowych marketingowych marketingowych marketingowych "
  ),
  active_account_consent_marketing_expansion_consent:
    themeScheme.MessageScheme.default(
      "essa ler com atenção a mensagem de expansão do consentimento de marketing"
    ),
  active_account_consent_less: themeScheme.MessageScheme.default("Zwiń"),
  active_account_consent_more: themeScheme.MessageScheme.default("Rozwiń"),
  active_account_symbol_required_field_consent:
    themeScheme.MessageScheme.default("*"),
});

export const IBoxActiveAccountSettingsScheme = z.object({
  active_account_input_typo:
    themeScheme.InputIdScheme.default("input$$1").catch("input$$1"),
  active_account_password_details_typo:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  active_account_password_details_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  active_account_action_button_typo:
    themeScheme.ButtonIdScheme.default("button$$1").catch("button$$1"),
  active_account_consent_select_all_typo:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  active_account_consent_select_all_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  active_account_consent_typo:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  active_account_consent_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  active_account_showMoreLess_typo:
    themeScheme.ButtonIdScheme.default("button$$1").catch("button$$1"),
  active_account_consent_elements_gap:
    themeScheme.SizeCSSScheme.default("16px").catch("16px"),
  active_account_symbol_required_field_consent_typo:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  active_account_symbol_required_field_consent_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  active_account_consent_error_typo:
    themeScheme.TypoIdScheme.default("typo$$1").catch("typo$$1"),
  active_account_consent_error_color:
    themeScheme.ColorIdScheme.default("color$$1").catch("color$$1"),
  active_account_action_button_redirect:
    themeScheme.UrlScheme.default("/").catch("/"),
  active_account_correct_number_verification_redirect:
    themeScheme.UrlScheme.default("/").catch("/"),
  active_account_invalid_token_redirect:
    themeScheme.UrlScheme.default("/").catch("/"),
});
